

import { Helmet } from "react-helmet-async";

const Meta = ({
    title = "Trillium Sourcing Corporation | Global Procurement Excellence",
    description = "Specialized defence procurement and global sourcing partner serving government agencies, OEMs, and international clients.",
    keywords = "defence procurement, global sourcing, OEM",
}) => {
    return (
        <Helmet >
            <title>{title}</title>

            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Helmet>
    );
};

export default Meta;
